import BaseValidator from 'services/validations/base-validator';
import {groupObjectsByProp} from 'helpers/array-helper';

export default class MinTeamsValidator extends BaseValidator {
    private minTeams: number = 0;

    protected runValidation(): void {
        // @ts-ignore
        const {sportConfig} = this.dependencies;

        this.minTeams = sportConfig.getConfigProp('minTeams', 0);

        if (this.isTeamsQuantityInsufficient()) {
            this.addError(`The min teams is ${this.minTeams}.`);
        }
    }

    private isTeamsQuantityInsufficient(): boolean {
        const teamsQuantity = this.calcTeamsQuantityInEditedLineup();

        return teamsQuantity < this.minTeams;
    }

    private calcTeamsQuantityInEditedLineup(): number {
        // @ts-ignore
        const {lineupPlayers} = this.dependencies;

        const teams = groupObjectsByProp(lineupPlayers, 'team');

        return Object.keys(teams).length;
    }
}
